<template>
    <div class="toggle">
        <label class="toggle__label" v-if="label">{{ label }}</label>
        <div v-on:click="click">
            <input type="checkbox"
                   v-bind:checked="value"
                   v-bind:value.boolean="value"
                   v-on:input="$emit('input', returnValue)"
            />
            <span v-html="this.value ? 'ON' : 'OFF'"></span>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            returnValue: function () {
                return this.value;
            }
        },
        props: {
            click: {
                default: function() {},
                type: Function
            },
            label: {
                default: null,
                type: String
            },
            value: {
                required: true,
                type: Boolean
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/Toggle.vue